export default function CarouselResource(module) {
    angular.module(module || 'app')
        .factory('carouselResource', carouselResource);

    carouselResource.$inject = ['$http'];
    function carouselResource($http) {
        return {
            slides: function (params) {
                return $http.get('/api/carousel/', {
                    params: params
                });
            }
        };
    }
};